import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";

import type { HostReceiptType } from "@/lib/gql/__generated__/graphql";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { HostReceiptDownloadURL_ManagementSalesReceiptsPage_Query } from "../repository/query/host-receipt-download-url/query";

export const useDownloadReceipt = (hotelID: string) => {
	const apolloClient = useApolloClient();
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const onDownloadReceipt = useCallback(
		async (receiptType: HostReceiptType, uniqueID: string) => {
			showLoadingScreenCallback();
			try {
				// URL は数分で失効するので、押すたびに取り直す
				const { data } = await apolloClient.query({
					query: HostReceiptDownloadURL_ManagementSalesReceiptsPage_Query,
					variables: { hotelID, receiptType, uniqueID },
					fetchPolicy: "no-cache",
				});

				// サーバーが添付ファイルとして返すので、画面を離れずに保存される
				window.location.assign(data.hostReceiptDownloadURL);
			} catch {
				notifyUserEventInfo({
					variant: "error",
					title: "領収書をダウンロードできませんでした",
					description: "時間をおいて再度お試しください。",
				});
			} finally {
				hideLoadingScreenCallback();
			}
		},
		[apolloClient, hotelID, showLoadingScreenCallback, hideLoadingScreenCallback],
	);

	return { onDownloadReceipt };
};
